var exports = {
  "a": "Box__26bvLV",
  "A": "PotentiallyDirty__MS_Jh2",
};

module.exports = exports;
